import DeleteIcon from '@mui/icons-material/Delete';
import {
  MenuItem,
  TextField,
  Box,
  IconButton,
} from "@mui/material";

import { BlockScheduleRow } from "@caredna-marlin/utils/blockScheduling";

type Props = {
  onChange: (value: BlockScheduleRow) => void;
  onRemove: () => void;
  row: BlockScheduleRow;
};

const formatHour = (hour: number): string => {
  const period = hour < 12 ? "am" : "pm";
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}${period}`;
}

const BlockScheduleOption = ({ row, onChange, onRemove }: Props) => {
  return <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
    <TextField
      select
      label="Start"
      size="small"
      sx={{ width: "6em", mr: 2 }}
      value={row.start}
      onChange={e => onChange({ ...row, start: e.target.value })}
    >
      <MenuItem value="">Blank</MenuItem>
      {Array.from({ length: 24 }, (_, i) => (
        <MenuItem key={i} value={i.toString()}>
          {formatHour(i)}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      select
      label="End"
      size="small"
      sx={{ width: "6em" }}
      value={row.end}
      onChange={e => onChange({ ...row, end: e.target.value })}
    >
      <MenuItem value="">Blank</MenuItem>
      {Array.from({ length: 24 }, (_, i) => (
        <MenuItem key={i} value={i.toString()}>
          {formatHour(i)}
        </MenuItem>
      ))}
    </TextField>
    <IconButton onClick={onRemove} size="small" aria-label="remove row">
      <DeleteIcon fontSize="small" />
    </IconButton>
  </Box>
}

export default BlockScheduleOption
